import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SickLeaveApplicationsListPage from './pages/SickLeaveApplicationsListPage';
import SickLeaveApplicationsDetailPage from './pages/SickLeaveApplicationsDetailPage';

const SickLeaveModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/applications" element={<SickLeaveApplicationsListPage />} />
      <Route path="/applications/:applicationId" element={<SickLeaveApplicationsDetailPage />} />
      <Route path="/" element={<Navigate to="/sick-leave/applications" replace />} />
      <Route path="*" element={<Navigate to="/sick-leave/applications" replace />} />
    </Routes>
  );
};

export default SickLeaveModule;
